import { render, staticRenderFns } from "./GramContactDm.vue?vue&type=template&id=9dd79a64"
import script from "./GramContactDm.vue?vue&type=script&lang=ts"
export * from "./GramContactDm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports